<mat-dialog-content class="dialog-content">
    <div class="dialog-header">
        <h2 class="dialog-title">New Custom Record</h2>
        <button mat-icon-button mat-dialog-close class="dialog-close" aria-label="Close" data-test="dialog-close">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <form [formGroup]="customRecordForm" class="dialog-form">

        <!-- Display name -->
        <div class="form-section">
            <span class="section-label">Label <span class="unit-note">· optional, auto-generated if blank</span></span>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <input matInput formControlName="displayName" placeholder="e.g. FY 2024 adj.">
            </mat-form-field>
        </div>

        <!-- Date — Full Fiscal Year only -->
        <div class="form-section">
            <span class="section-label">Date</span>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-select formControlName="periodKeyDate">
                    @for (d of availableFullFiscalYearDates; track d) {
                        <mat-option [value]="d">{{ d | date }}</mat-option>
                    }
                </mat-select>
                @if (customRecordForm.controls.periodKeyDate.hasError('required')) {
                    <mat-error>Date is required</mat-error>
                }
            </mat-form-field>
        </div>

        <!-- Financial fields — 2×2 grid -->
        <div class="form-section">
            <span class="section-label">Financials <span class="unit-note">· in millions</span></span>
            @if (!earningBase) {
                <p class="no-earning-base-hint">
                    Select an Earnings Metric on the valuation form before creating a custom record.
                </p>
            }
            @if (earningBase) {
                <div class="fields-grid">

                    <div class="field-item">
                        <label class="field-label">Revenue</label>
                        <input class="field-input" type="number" formControlName="revenue">
                    </div>

                    <div class="field-item">
                        <label class="field-label">{{ earningBase }}</label>
                        <input class="field-input" type="number" formControlName="earningsAmount">
                    </div>

                    <div class="field-item">
                        <label class="field-label">Net Debt</label>
                        <input class="field-input" type="number" formControlName="netDebt">
                    </div>

                    <div class="field-item">
                        <label class="field-label">Enterprise Value</label>
                        <input class="field-input" type="number" formControlName="enterpriseValue">
                    </div>

                </div>
            }
        </div>

    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-flat-button color="primary" [disabled]="customRecordForm.invalid || !earningBase" (click)="onSave()">Save</button>
</mat-dialog-actions>
